import { DatePicker } from '@mui/x-date-pickers';
import { useFormContext, Controller } from 'react-hook-form';
import { TextFieldProps } from '@mui/material';
import dayjs from 'dayjs';

type Props = TextFieldProps & {
  name: string;
};

export default function RHFDate({ name, helperText, ...other }: Props) {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <DatePicker
          {...field}
          value={field.value ? dayjs(field.value) : null}
          onChange={(value) => field.onChange(value ? value.toISOString() : null)}
          slotProps={{
            field: { clearable: true },
            textField: {
              fullWidth: true,
              size: "small",
              error: !!error,
              helperText: error?.message ?? helperText,
              // ... ваши остальные пропсы
              sx: {
                ...other.sx,
                // Таргетируемся на секции даты (те самые, что вы нашли в инспекторе)
                '& .MuiPickersSectionList-section': {
                  font: 'menu', // Применяем ваш шрифт
                  fontSize: '0.75rem', // Явно задаем размер для small (обычно 14px)
                },
                // Для MUI 7 также может потребоваться этот селектор:
                '& .MuiInputBase-input': {
                  display: 'flex', // Чтобы секции выравнивались корректно
                  alignItems: 'center',
                }
              }
            }
          }}
        />
      )}
    />
  );
}
